export default {"src":"/_next/static/media/socialMedia_Lucky_Spin.5516d487.gif","height":300,"width":300};